import { render } from "./HeadlineReport.vue?vue&type=template&id=a98ce838&scoped=true"
import script from "./HeadlineReport.vue?vue&type=script&lang=js"
export * from "./HeadlineReport.vue?vue&type=script&lang=js"

import "./HeadlineReport.vue?vue&type=style&index=0&id=a98ce838&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a98ce838"]])

export default __exports__